export default "__VITE_ASSET__48b67a1d__"